export const MAX_LENGTH_OBS_ODONTO = 4000

export const MAX_LENGTH_LOCAL_ODONTO = 200
